import React from 'react';
import { LicenseInfo } from '@mui/x-license';
import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

import { GlobalErrorBoundary, LoaderGlobal, Theming, ToastContainer } from '@bloomays-lib/ui.shared';
import { Auth0ProviderConfig, AuthApolloProvider } from '@bloomays-lib/common.auth/browser';
import type { Auth0Context, Env } from '@bloomays-lib/types.shared';
import fr from '@bloomays-lib/utils.shared';
import CssBaseline from '@mui/material/CssBaseline';

import RouterWrapper from '../wrappers/RouterWrapper';
import { Logger } from '../services/service-logger';
import { getApolloConfig } from '../apollo/config';

const logger = Logger('Client App');

LicenseInfo.setLicenseKey(
  'd2c4d17be9526eea0b78937679baa0d7Tz0xMjMyNDAsRT0xNzk3NDY1NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
);

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      fr,
    },
    lng: 'fr', // if you're using a language detector, do not define the lng option
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

type AppProps = {
  auth0ProviderConfig: Auth0ProviderConfig;
  mockAuth0Context?: Auth0Context;
  env: Env;
};

const apolloStoreConfig = getApolloConfig(logger);

const App = ({ auth0ProviderConfig, mockAuth0Context, env }: AppProps): React.ReactNode => {
  return (
    <Theming>
      <CssBaseline />
      <GlobalErrorBoundary>
        <AuthApolloProvider
          auth0ProviderConfig={auth0ProviderConfig}
          mockAuth0Context={mockAuth0Context}
          logger={logger}
          loaderAuthComponent={<LoaderGlobal waitingText="Chargement jeton utilisateur" />}
          env={env}
          apolloStoreConfig={apolloStoreConfig}
        >
          <RouterWrapper></RouterWrapper>
          <ToastContainer />
        </AuthApolloProvider>
      </GlobalErrorBoundary>
    </Theming>
  );
};

export default App;
